module.exports = __webpack_public_path__ + "img/noticeBanner.1e5cb053.png";